import React from 'react';
import PropTypes from 'prop-types';
import {Button, OverlayTrigger, Tooltip} from "react-bootstrap";
import { connect } from 'react-redux';

import {driverDepositCancelInvoiced, act_showPopinConfirm} from  "../../actions";

const Internal = ({deposit, showPopupConfirm}) => {

  if (deposit.is_invoiced && (deposit.status.cancel_status !== 'total')) {
    const disabled = !deposit.can_cancel_invoiced;

    const popoverInfos = () => {
      return <Tooltip id="deposit-cannot-cancel-invoiced">
        L'annulation de facturation n'est plus possible après la date limite de retour.
      </Tooltip>;
    };

    return <div className="DepositDriverHistoryCancelInvoicedButton">
      {disabled
        ? <OverlayTrigger trigger={['hover', 'focus']} placement="left" overlay={popoverInfos()} rootClose={true} transition={false}>
          <div className="cancel_invoiced_disabled">
            <Button variant="danger" size="xs">Annuler</Button>
          </div>
        </OverlayTrigger>
        : <Button variant="danger" size="xs" onClick={() => {showPopupConfirm(deposit.driver, deposit.id);}}>Annuler</Button>
      }
    </div>;
  }
  return null;
};
Internal.propTypes = {
  deposit: PropTypes.object.isRequired,
  showPopupConfirm: PropTypes.func.isRequired,
};

export const DepositDriverHistoryCancelInvoicedButton = connect(
  () => {
    return {};
  },
  (dispatch) => {
    return {
      "showPopupConfirm": (driver_id, deposit_driver_id) => {
        dispatch(act_showPopinConfirm(
          'Êtes vous certain de vouloir annuler cette facturation ?',
          driverDepositCancelInvoiced(driver_id, deposit_driver_id)
        ));
      }
    };
  }
)(Internal);
